<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown
    v-show="role >= 4"
    vs-custom-content
    vs-trigger-click
    class="cursor-pointer"
  >
    <feather-icon
      icon="BellIcon"
      ref="notification-dropdown"
      class="cursor-pointer notification mt-1 sm:mr-6 mr-2"
      :badge="unreadNotifications.length"
    />

    <vs-dropdown-menu
      class="notification-dropdown dropdown-custom vx-navbar-dropdown"
    >
      <div class="notification-top text-center p-5 bg-danger text-white">
        <h3 class="text-white">{{ unreadNotifications.length }} New</h3>
        <p class="opacity-75">Alert Notifications</p>
      </div>

      <component
        :is="scrollbarTag"
        ref="mainSidebarPs"
        class="scroll-area--nofications-dropdown p-0 mb-10"
        :settings="settings"
        :key="$vs.rtl"
      >
        <ul class="bordered-items">
          <li
            v-for="ntf in unreadNotifications"
            :key="ntf.index"
            @click="notificationClick(ntf.imei)"
            class="flex justify-between px-4 py-4 notification cursor-pointer"
          >
            <div class="flex items-start">
              <feather-icon
                icon="AlertOctagonIcon"
                svgClasses="text-danger stroke-current mr-1 h-6 w-6"
              ></feather-icon>
              <div class="mx-2">
                <span
                  class="font-medium block notification-title text-danger"
                  >{{ ntf.alert }}</span
                >
                <span>
                  <small>{{ `Plate: ${ntf.plate}` }}</small>
                </span>
                <br />
                <span>
                  <small>{{ `Device Name: ${ntf.device_name}` }}</small>
                </span>
                <br />
                <span>
                  <small>{{ `Position: ${ntf.position}` }}</small>
                </span>
                <br />
                <span>
                  <small>{{ `Time: ${ntf.time}` }}</small>
                </span>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap">{{
              elapsedTime(ntf.time)
            }}</small>
          </li>
        </ul>
      </component>

      <div
        @click="allNotificationClick"
        class="checkout-footer fixed bottom-0 rounded-b-lg text-danger w-full p-2 font-semibold text-center border border-b-0 border-l-0 border-r-0 border-solid d-theme-border-grey-light cursor-pointer"
      >
        <span>View All Alert</span>
      </div>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      privilege: [
        '',
        'Super Administrator',
        'Administrator',
        'Admin Cabang',
        'General User',
        'Dispatcher',
        'Limited User'
      ],
      role: -1,
      // unreadNotifications: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      }
    }
  },

  created() {
    this.role =
      localStorage.getItem('userInfo') !== null
        ? this.privilege.indexOf(
            JSON.parse(localStorage.getItem('userInfo')).privilege
          )
        : -1
  },

  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    unreadNotifications() {
      return this.$store.state.notification.unreadNotification
    }
  },
  methods: {
    elapsedTime(startTime) {
      const x = new Date(startTime)
      const now = new Date()
      let timeDiff = now - x
      timeDiff /= 1000

      const seconds = Math.round(timeDiff)
      timeDiff = Math.floor(timeDiff / 60)

      const minutes = Math.round(timeDiff % 60)
      timeDiff = Math.floor(timeDiff / 60)

      const hours = Math.round(timeDiff % 24)
      timeDiff = Math.floor(timeDiff / 24)

      const days = Math.round(timeDiff % 365)
      timeDiff = Math.floor(timeDiff / 365)

      const years = timeDiff

      if (years > 0) {
        return `${years + (years > 1 ? ' Years ' : ' Year ')}ago`
      } else if (days > 0) {
        return `${days + (days > 1 ? ' Days ' : ' Day ')}ago`
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? ' Hrs ' : ' Hour ')}ago`
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? ' Mins ' : ' Min ')}ago`
      } else if (seconds > 0) {
        return seconds > 1 ? seconds + ' sec ago' : 'Just Now'
      }

      return 'Just Now'
    },
    // Method for creating dummy notification time
    randomDate({ hr, min, sec }) {
      const date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    },
    notificationClick(imei) {
      this.$refs['notification-dropdown'].click()
      let today = new Date()
      let date = `${today.getFullYear()}-${(today.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`

      let start = `${date} 00:00`
      let end = `${date} 23:59`

      this.$store.dispatch('alarm/setAlarm', {
        device: imei,
        start_time: start,
        end_time: end
      })
      // localStorage.setItem('alertParams', JSON.stringify({ device: imei, start_time: start, end_time: end }))
      if (this.$route.name !== 'alert') this.$router.push({ path: '/alert' })
    },
    allNotificationClick() {
      this.$refs['notification-dropdown'].click()
      this.$store.dispatch('alarm/clearAlarm')
      if (this.$route.name !== 'alert') this.$router.push({ path: '/alert' })
    }
  }
}
</script>
